<template>
  <div class="container">
    <div class="content" v-if="!isMobile">
      <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :show-success="activeSuccessFlag" :show-button="true" :close-btn-img="closeBtnImg" :error-msg="errorMsg" @close="closeDialog" />
      <sys-loading :loading="loading" />
      <div class="form-content">
        <img class="logo" alt src="../assets/road/logo.png" />
        <img class="title" alt src="../assets/road/title.png" />
        <div class="tags">
          <span :class="isRegisterAction ? 'tag active' : 'tag'" @click="isRegisterAction = true">ĐĂNG KÝ</span>
          <span :class="!isRegisterAction ? 'tag active' : 'tag'" @click="isRegisterAction = false">ĐĂNG NHẬP</span>
        </div>
        <div class="form-input">
          <img src="../assets/road/icon-username.png" />
          <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
        </div>
        <div class="form-input" v-show="isRegisterAction">
          <img src="../assets/road/icon-phone.png" />
          <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" />
        </div>
        <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
          <img src="../assets/road/icon-password.png" />
          <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
        </div>
        <div class="form-input" v-show="isRegisterAction">
          <img src="../assets/road/icon-email.png" />
          <input v-model="form.email" autocomplete="off" placeholder="Email" />
        </div>
        <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0; position: relative;">
          <input v-model="form.verificationCode" autocomplete="off" maxlength="4" style="text-indent:16px;" />
          <div class="codeImg">
            <span @click="getVerify" v-if="codeImg" class="validateCode">
              <img class="img" :src="codeImg" alt="code" />
            </span>
          </div>
        </div>
        <a v-if="!isRegisterAction" class="error" href="https://www.8day.com">Quên Mật Khẩu?</a>
        <!-- <div
          class="submitBtn"
          @click="submitAction(isRegisterAction ? '1' : '2')"
        >
          {{ isRegisterAction ? "ĐĂNG KÝ" : "ĐĂNG NHẬP" }}
        </div> -->

        <v-captcha ref="vcaptcha2" :dialogVisible="dialogVisible" :showCheck="showCheck" :style="{
            width: '43.9678%',
            height: '9.4444%'
          }" :vstyle="{
            width: '100%',
            height: '100%',
            top: '18px'
          }" :nativeButton="{
            width: '100%',
            height: '100%'
          }" @cb="handleConfirm">
          <div v-show="isRegisterAction" class="submitBtn submitBtn1" @click="submitAction(1)">
            ĐĂNG KÝ
          </div>
        </v-captcha>
        <div v-show="!isRegisterAction" class="submitBtn" @click="submitAction(2)">
          ĐĂNG NHẬP
        </div>
      </div>
    </div>
    <div class="root" v-if="isMobile">
      <sys-dialog v-show="dialogVisible" :bgi="dialogBgi" :show-success="activeSuccessFlag" :show-button="true" :close-btn-img="closeBtnImg" :error-msg="errorMsg" @close="closeDialog" />
      <sys-loading :loading="loading" />
      <div class="form-content">
        <img class="logo" alt src="../assets/road/logo.png" />
        <img class="title" alt src="../assets/road/title.png" />
        <div class="tags">
          <span :class="isRegisterAction ? 'tag active' : 'tag'" @click="isRegisterAction = true">ĐĂNG KÝ</span>
          <span :class="!isRegisterAction ? 'tag active' : 'tag'" @click="isRegisterAction = false">ĐĂNG NHẬP</span>
        </div>
        <div class="form-input">
          <img src="../assets/road/icon-username.png" />
          <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
        </div>
        <div class="form-input" v-show="isRegisterAction">
          <img src="../assets/road/icon-phone.png" />
          <input v-model="form.phone" placeholder="Số điện thoại" maxlength="10" oninput="value=value.replace(/^\D/, '')" />
        </div>
        <div class="form-input" :style="!isRegisterAction ? { marginBottom: 0 } : ''">
          <img src="../assets/road/icon-password.png" />
          <input v-model="form.password" type="password" autocomplete="new-password" placeholder="Mật khẩu" />
        </div>
        <div class="form-input" v-show="isRegisterAction">
          <img src="../assets/road/icon-email.png" />
          <input v-model="form.email" autocomplete="off" placeholder="Email" />
        </div>
        <div class="form-input" v-show="isRegisterAction" style="margin-bottom: 0; position: relative;">
          <input v-model="form.verificationCode" autocomplete="off" maxlength="4" style="text-indent:16px;" />
          <div class="codeImg">
            <span @click="getVerify" v-if="codeImg" class="validateCode">
              <img class="img" :src="codeImg" alt="code" />
            </span>
          </div>
        </div>
        <a v-if="!isRegisterAction" class="error" href="https://www.8day.com">Quên Mật Khẩu?</a>
        <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="handleConfirm" :vstyle="{
            width: '43.7333vw',
            height: '7.6461vh',
            top: '10vw'
          }" :nativeButton="{
            width: '43.7333vw',
            height: '7.6461vh'
          }">
          <div v-show="isRegisterAction" class="submitBtn submitBtn1" @click="submitAction(1)">
            ĐĂNG KÝ
          </div>
        </v-captcha>
        <div v-show="!isRegisterAction" class="submitBtn" @click="submitAction(2)">
          ĐĂNG NHẬP
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import {
  FORM_VALID_MESSAGE,
  DOMAIN_AGENT_CODE,
  CONTRACTS
} from "../utils/constant";
import { userRegister, userLogin, createCustomer, getCode } from "../utils/request";
import { encodePlatformUrl, validForm, isMobile } from "../utils/tools";
import { captcha } from "@/mixins/captcha";
export default {
  name: "Sport",
  mixins: [captcha],
  data() {
    return {
      codeImg: '',
      isMobile: isMobile(),
      loading: false,
      isRegisterAction: true,
      dialogVisible: false,
      activeSuccessFlag: false,
      dialogBgi: require("../assets/road/bgi-message.png"),
      closeBtnImg: require("../assets/road/bgi-btn-submit.png"),
      contacts: CONTRACTS,
      form: {
        by: 1,
        username: "",
        verificationCode: "",
        userName: "",
        phone: "",
        password: "",
        email: "",
        link: "",
        domain: "",
        inviteCode: null
      },
      errorMsg: {
        title: "",
        content: ""
      }
    };
  },
  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getVerify();
  },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    submitAction(type) {
      let errorMsg = validForm(type, this.form);
      if (Object.keys(errorMsg).length !== 0) {
        this.setDialogMsg(errorMsg.title, errorMsg.content);
        return;
      }
      this.loading = true;
      // 登陆
      if (type == 2) {
        let temp = Object.assign({}, this.form);
        let params = {
          acctType: 6,
          by: 1,
          email: temp.email,
          userName: temp.userName,
          phone: temp.phone,
          password: md5(temp.password)
        };
        this.login(params);
      } else {
        const inviteCode = DOMAIN_AGENT_CODE[location.host] || "";
        this.form.inviteCode = inviteCode;
        this.form.domain = location.host;
        this.form.username = this.form.userName;
        this.register();
      }
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.activeSuccessFlag = true;
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loggedTitle,
              FORM_VALID_MESSAGE.loggedMsg
            );
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        this.loading = false;
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      params.verificationCode = this.form.verificationCode;
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.activeSuccessFlag = true;
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.getVerify();
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
@media only screen and (min-width: 1420px) and (max-width: 1680px) {
  .container .content .submitBtn,
  .container .content .tags .tag {
    font-size: 24px !important;
  }
}
.container {
  ::-ms-input-placeholder {
    font-size: 24px;
    color: #000c74;
  }
  ::-webkit-input-placeholder {
    font-size: 24px;
    color: #000c74;
  }
  .content {
    width: 100vw;
    height: 100vh;
    background-image: url("../assets/road/bgi-pc.jpg");
    background-size: 100% 100%;
    padding: 0;
    margin: 0;
    box-sizing: border-box;

    .form-content {
      width: 38.8652%;
      height: 100%;
      float: right;
      margin-right: 8.02%;
      background-image: url("../assets/road/bgi-dialog-pc.png");
      background-size: 100% 106%;
      box-sizing: border-box;
      display: flex;
      flex-flow: column;
      justify-content: flex-start;
      align-items: center;
      padding-top: 1.6666%;

      img.logo {
        height: 13.3333%;
      }

      img.title {
        width: 70%;
        height: 21.3%;
        transform: rotate(-3deg);
      }

      .tags {
        width: 70%;
        height: 7.87%;
        position: relative;
        top: -1%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: "Montserrat-Black";
        font-size: 30px;
        color: #00115b;

        .tag {
          width: 45%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-image: url("../assets/road/bgi-btn-normal.png");
          background-size: 100% 100%;
          cursor: pointer;
          position: relative;

          &.active {
            background-image: url("../assets/road/bgi-btn-active.png");
          }

          &:active {
            top: 2px;
          }
        }
      }

      .form-input {
        width: 60%;
        height: 7.2592%;
        position: relative;
        margin-bottom: 10px;

        .codeImg {
          cursor: pointer;
          width: 150px;
          height: 100%;
          position: absolute;
          right: 0;
          top: 1px;
          .img {
            width: 150px;
            position: unset;
            height: 98%;
            border-radius: 20px;
          }
        }

        img {
          width: 30px;
          height: 30px;
          position: absolute;
          top: calc(50% - 15px);
          left: 50px;
        }

        input {
          width: 100%;
          height: 100%;
          background: transparent url("../assets/road/bgi-input.png") no-repeat;
          background-size: 100% 100%;
          border: none;
          outline: none;
          text-indent: 100px;
          font-size: 24px;
          color: #000c74;
        }
      }

      a.error {
        display: block;
        margin: 20px;
        color: #ffffff;
        font-size: 20px;
        text-decoration: none;
      }

      .submitBtn {
        width: 43.9678%;
        height: 9.4444%;
        background-image: url("../assets/road/bgi-btn-submit.png");
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: Montserrat-Black;
        font-size: 30px;
        color: #00115b;
        cursor: pointer;
        position: relative;
        top: 18px;

        &:active {
          top: 20px;
        }
      }
      .submitBtn1 {
        width: 100%;
        height: 100%;
      }
    }

    /deep/ .modal {
      width: 604px;
      height: 778px;
      padding: 0 !important;

      .modal-content {
        height: 100%;
        width: 70%;
        margin: 0 auto;

        p {
          font-family: Montserrat-Black !important;
          width: 100%;
          word-break: break-all;
          word-wrap: break-word;

          &.modal-text {
            font-family: sans-serif !important;
          }
        }
      }

      .close-btn {
        bottom: 20% !important;
        height: 80px !important;
        letter-spacing: 2px;
      }

      .modal-title {
        font-size: 36px;
      }
    }
  }
}

.root {
  width: 100vw;
  height: 100vh;
  background-image: url("../assets/road/bgi-h5.jpg");
  background-size: 100% 100%;
  padding: 0;
  margin: 0;
  box-sizing: border-box;

  ::-ms-input-placeholder {
    font-size: 1.2em;
    color: #000c74;
  }
  ::-webkit-input-placeholder {
    font-size: 1.2em;
    color: #000c74;
  }

  /deep/ .modal {
    width: 100%;
    max-width: 100% !important;
    height: 70vh;
    padding: 0 !important;

    .modal-content {
      height: 100%;
      width: 75%;
      margin: 0 auto;

      p {
        font-family: Montserrat-Black !important;
        width: 100%;
        word-break: break-all;
        word-wrap: break-word;

        &.modal-text {
          font-family: sans-serif !important;
        }
      }
    }

    .close-btn {
      font-family: Montserrat-Black !important;
      font-size: 1.2em !important;
      color: #000c74 !important;
      bottom: 20% !important;
      height: 15vw !important;
      width: 50% !important;
      left: 25% !important;
      letter-spacing: 2px;
    }

    .modal-title {
      font-size: 1.5em;
    }
  }

  .form-content {
    width: 100%;
    background-image: url("../assets/road/bgi-dialog-h5.png");
    background-size: 100% 100%;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 2vw;
    padding-bottom: 10vh;

    img.logo {
      height: 14.2428vh;
    }

    img.title {
      width: 80%;
      height: 21.3vh;
      transform: rotate(-3deg);
    }

    .tags {
      width: 75%;
      height: 6.147vh;
      position: relative;
      top: -1%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: "Montserrat-Black";
      font-size: 1em;
      color: #00115b;

      .tag {
        width: 45%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url("../assets/road/bgi-btn-normal.png");
        background-size: 100% 100%;

        &.active {
          background-image: url("../assets/road/bgi-btn-active.png");
        }
      }
    }

    .form-input {
      width: 70%;
      height: 7.871vh;
      position: relative;
      margin-top: 2vw;

      .codeImg {
        cursor: pointer;
        width: 150px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 1px;
        .img {
          width: 150px;
          position: unset;
          height: 98%;
          border-radius: 20px;
        }
      }

      img {
        width: 6vw;
        height: 6vw;
        position: absolute;
        top: calc(50% - 3vw);
        left: 5vw;
      }

      input {
        width: 100%;
        height: 100%;
        background: transparent url("../assets/road/bgi-input.png") no-repeat;
        background-size: 100% 100%;
        border: none;
        outline: none;
        text-indent: 15vw;
        font-size: 0.8em;
        color: #000c74;
      }
    }

    a.error {
      display: block;
      margin: 20px;
      color: #ffffff;
      font-size: 20px;
      text-decoration: none;
    }

    .submitBtn {
      width: 43.7333vw;
      height: 7.6461vh;
      background-image: url("../assets/road/bgi-btn-submit.png");
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: Montserrat-Black;
      font-size: 1.2em;
      color: #00115b;
      position: relative;
      top: 10vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Road.vue